import type { ResourceArticle } from '~/types/ResourceArticle'

export const obsessionsAndCompulsionsArticle: ResourceArticle = {
  uid: 'obsessions-and-compulsions',
  thumbnailImageUrl: 'https://cdn.hubofhope.co.uk/public/img/thumbs/RESOURCES_OCD_800x800.jpg',
  thumbnailImageAlt: 'Obsessions & compulsions',
  title: 'Obsessions & compulsions',
  supportNeedCategoryLabel: 'OCD',
  supportNeedCategoryUid: 'hW2ZygLtmGcx8S3ef2ek',
  isFeatured: true,
  excerpt:
    'Sometimes we can feel compelled to check things repeatedly, or to repeat certain thoughts or actions to stave off anxiety or worrying thoughts. Troubling thoughts are sometimes called obsessions, and repeated checks or actions are sometimes called compulsions.',
  content: `
  <div class="prose mt-4">
    <p class="font-bold">
      Sometimes we can feel compelled to check things repeatedly, or to repeat certain thoughts or actions to stave off anxiety or worrying thoughts. Troubling thoughts are sometimes called obsessions, and repeated checks or actions are sometimes called compulsions.
    </p>
  
    <p class="mt-4">
      For more see <a href="/resource/understanding-anxiety" class="text-blue-500 underline hover:text-blue-700">Understanding anxiety</a>. These experiences are sometimes called OCD or obsessive-compulsive disorder.
    </p>
  
    <h2 class="font-semibold text-lg font-brown text-primary mt-8">How to seek help</h2>
    <p>
      In terms of what can help, there are a number of self-help resources. Therapy or counselling can help to identify and understand what might have led to our feelings of anxiety, what drives our obsessions and compulsions, and what might be keeping it going. It can help us find ways to support ourselves and to regulate our physical and emotional states.
    </p>
  
    <figure class="my-10">
      <img src="https://cdn.hubofhope.co.uk/public/img/thumbs/ryoji-iwata-X53e51WfjlE-unsplash_800x800.jpg"
           alt="OCD article image" 
           class="max-w-md w-full h-auto rounded shadow-md mx-auto">
    </figure>
  </div>`
}
